import { IFilterRequest } from '@services/queries/equipments/getEquipments/getEquipments';
import { IFilter } from '@pages/Products/Products';

export const getFilterRequest = (
  filtersData: Partial<IFilter>,
  isActiveTab: boolean,
  sort?: string,
  direction?: 'ASC' | 'DESC' | undefined,
): IFilterRequest => {
  const {
    modelsName = [],
    users = [],
    status = [],
    tags = [],
    manufactorNames = [],
  } = filtersData;
  const lowerManufacturerNames = manufactorNames
    .filter(item => item.active)
    .map(item => item.name.toLowerCase());

  return {
    modelNames:
      modelsName.filter(item => item.active).length > 0
        ? modelsName
            .filter(item => item.active)
            .map(item => item.name.toLowerCase())
        : undefined,
    tagNames:
      tags.length > 0 ? tags.map(item => item.name.toLowerCase()) : undefined,
    statusId:
      status.filter(item => item.active && item.status.id !== undefined)
        .length > 0
        ? status
            .filter(item => item.active && item.status.id !== undefined)
            .map(item => item.status.id as string)
        : undefined,
    usersId:
      users.filter(item => item.active && item.user.id !== undefined).length > 0
        ? users
            .filter(item => item.active && item.user.id !== undefined)
            .map(item => item.user.id as string)
        : undefined,
    manufactorNames:
      lowerManufacturerNames.length > 0 ? lowerManufacturerNames : undefined,
    purchasedDateStart: filtersData.startDate
      ? filtersData.startDate
      : undefined,
    purchasedDateEnd: filtersData.endDate ? filtersData.endDate : undefined,
    sort: isActiveTab ? sort || filtersData.sort : undefined,
    direction: direction || filtersData.direction,
  };
};
